import React from 'react';
import { Calendar, Play, Users, ArrowRight } from 'lucide-react';
import './HowItWorks.css';

const HowItWorks = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const headerHeight = 80;
      const rect = element.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const elementTop = rect.top + scrollTop;
      const targetPosition = elementTop - headerHeight;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  const steps = [
    {
      id: 1,
      icon: Calendar,
      title: "Book a consultation",
      description: "Schedule your free assessment session to understand your learning needs and goals.",
      color: "var(--primary-blue)"
    },
    {
      id: 2,
      icon: Play,
      title: "Start with a free online session",
      description: "Experience our one-on-one tutoring with a complimentary demo class tailored to your needs.",
      color: "var(--dark-blue)"
    },
    {
      id: 3,
      icon: Users,
      title: "Become a member",
      description: "Choose your personalized package and begin your journey to academic excellence.",
      color: "var(--primary-blue)"
    }
  ];

  return (
    <section className="how-it-works section" id="how-it-works">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">
            How it <span className="gradient-text">Works</span>
          </h2>
          <p className="section-description">
            Getting started with personalized tutoring is simple and straightforward
          </p>
        </div>

        <div className="steps-container">
          {steps.map((step, index) => (
            <React.Fragment key={step.id}>
              <div className="step-card">
                <div className="step-number">{step.id}</div>
                <div className="step-icon-container">
                  <step.icon className="step-icon" style={{ color: step.color }} />
                </div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
              
              {index < steps.length - 1 && (
                <div className="step-connector">
                  <ArrowRight className="connector-arrow" />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>

        <div className="cta-section">
          <button className="btn-primary" onClick={scrollToContact}>
            Start Your Free Session
            <ArrowRight className="btn-icon" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
